import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('poker', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48"
  }, [_createVNode("g", {
    "stroke": "none",
    "stroke-width": props.strokeWidth,
    "fill": "none",
    "fill-rule": "evenodd",
    "stroke-linejoin": props.strokeLinejoin
  }, [_createVNode("g", {
    "transform": "translate(4.000000, 4.000000)",
    "stroke-width": props.strokeWidth
  }, [_createVNode("rect", {
    "stroke": props.colors[0],
    "fill": props.colors[1],
    "fill-rule": "nonzero",
    "x": "8",
    "y": "0",
    "width": "30",
    "height": "40"
  }, null), _createVNode("polygon", {
    "stroke": props.colors[0],
    "stroke-linecap": props.strokeLinecap,
    "points": "0 7.78947368 8 6 8 40"
  }, null), _createVNode("polygon", {
    "stroke": props.colors[2],
    "fill": props.colors[3],
    "fill-rule": "nonzero",
    "points": "23 14 18 20 23 26 28 20"
  }, null), _createVNode("path", {
    "d": "M14,6 L14,10",
    "stroke": props.colors[2],
    "stroke-linecap": props.strokeLinecap
  }, null), _createVNode("path", {
    "d": "M32,30 L32,34",
    "stroke": props.colors[2],
    "stroke-linecap": props.strokeLinecap
  }, null)])])]);
});